<div scrollY="true">
  <h1 class="text-align-center"> Your Profile </h1>
    <div class="container">
      @if (isLoaded) {
        <mat-col class="left">
          <h4 class="text-align-center"> Update Details </h4>
          <app-edit-user (userUpdated)="userUpdated()" [userToUpdate]="userToUpdate" [admin]="true" [isInModal]="false"></app-edit-user>
          <div class="center-column">
            <div class="wrapper center-column">
              <form [formGroup]="formGroup">
                <mat-col>
                  <mat-form-field class="form-field-width">
                    <mat-label>Password</mat-label>
                    <input matInput formControlName="passwordControl" [type]="'password'" (keyup.enter)="resetPassword()" required />
                  </mat-form-field>
                </mat-col>
                <div>
                  @for (validation of validation_messages.passwordControl; track validation) { @if ( formGroup.get('passwordControl').hasError(validation.type) &&
                  (formGroup.get('passwordControl').dirty || formGroup.get('passwordControl').touched) ) {
                  <div class="validation-error-message">
                    {{ validation.message }}
                  </div>
                  } }
                </div>
                <mat-form-field class="form-field-width">
                  <mat-label>Confirm Password</mat-label>
                  <input matInput formControlName="confirmPasswordControl" type="password" [type]="'password'" (keyup.enter)="resetPassword()" required />
                </mat-form-field>
                <div>
                  @for (validation of validation_messages.passwordControl; track validation) { @if ( formGroup.get('confirmPasswordControl').hasError(validation.type) &&
                  (formGroup.get('confirmPasswordControl').dirty || formGroup.get('confirmPasswordControl').touched) ) {
                  <div class="validation-error-message">
                    {{ validation.message }}
                  </div>
                  } }
                </div>
                <div>
                  @for (validation of validation_messages.matching_passwords; track validation) { @if ( formGroup.hasError(validation.type) &&
                  (formGroup.get('confirmPasswordControl').dirty || formGroup.get('confirmPasswordControl').touched) ) {
                  <div class="validation-error-message">
                    {{ validation.message }}
                  </div>
                  } }
                </div>
              </form>
              <huge-row class="mat-margin-top mat-justify-content-center">
                <button class="savebtn primary-btn" expand="full" (click)="resetPassword()">Save</button>
              </huge-row>
            </div>
          </div>
        </mat-col>
        }
    
        <mat-col class="right text-align-center">
          <h4 class="text-align-center"> 2 Factor Authentication </h4>
          @if (user && !user.OTPEnabled) {
          <div>
            <button (click)="activateOTP()" class="btn primary-btn"> Enable 2 Factor Authentication </button>
          </div>
          } @if (user && user.OTPEnabled) {
          <div>
            @if (secretSource) {
            <div class="current underlined">
              <p>Scan the QR code with Google Authenticator to get started!</p>
              <img src="{{ secretSourceURL }}" alt="OTP Secret Not Loading" />
              <p class="hexKey">{{ secretHex }}</p>
              <br />
            </div>
            }
            <div class="underlined">
              <span class="heading"></span>
              <button (click)="disableOTP()" class="btn btn-outline secondary-btn"> Disable 2 Factor Authentication </button>
              <br />
              <br />
              <br />
            </div>
            <br />
            <div class="underlined">
              <button (click)="renewOTP()" class="btn primary-btn"> Renew Authentication Secret </button>
              <p class="warning-text">Warning! You will have to rescan your secret with Google Authenticator.</p>
              <br />
            </div>
            <br />
            <div class="validate">
              <label>Validate OTP Secret:</label>
              <form [formGroup]="otpForm">
                <input matInput placeholder="Enter your latest OTP..." type="text" formControlName="otpControl" (keyup.enter)="validateOTP()" />
              </form>
              <button (click)="validateOTP()" class="btn btn-outline secondary-btn ion-margin"> Validate </button>
            </div>
          </div>
          }
        </mat-col>
    </div>
</div>
